export default {
  fade: "basic-fade",
  fadeAndScaleDown: "fade-and-scale-down",
  fadeAndMoveLeft: "fade-and-move-left",
};
